const ALL_TAG = "All";

class BartBitsBox extends HTMLElement {
  constructor() {
    super();

    this.tagButtons = Array.from(document.querySelectorAll(".button--bits"));
    this.tagNames = this.tagButtons.map((x) => x.innerHTML);
    this.modules = Array.from(document.querySelectorAll(".bits-content__module"));
    this.contentWrapper = this.querySelector(".bits-box-content");
    this.header = this.querySelector(".bits-box-header");
    this.currentTag = "";
    this.expanded = false;

    this._retrievePersistentData();
    this._refreshState();

    this.querySelectorAll(".button--bits").forEach(x => x.addEventListener("click", this._onFilterButtonClick.bind(this)));
    this.header.addEventListener("click", this._onHeaderClick.bind(this));
  }

  _retrievePersistentData() {
    const storedValue = window.sessionStorage.getItem("bart-bits-current-tag");
    const expanded = window.sessionStorage.getItem("bart-bits-expanded") === "true";
    if (storedValue === null) {
      this._setPersistentData(ALL_TAG, expanded);
    } else {
      this._setPersistentData(storedValue, expanded);
    }
  }

  _setPersistentData(tag, expanded) {
    window.sessionStorage.setItem("bart-bits-current-tag", tag);
    window.sessionStorage.setItem("bart-bits-expanded", expanded ? "true" : "false");
    this.currentTag = tag;
    this.expanded = expanded;
    this._refreshState();
  }

  _refreshState() {
    this._refreshExpansionState();
    this._refreshModuleVisibility();
    this._refreshButtonStates();
  }

  _refreshExpansionState() {
    if (this.expanded) {
      this.classList.add("bits-box--expanded");
      this.contentWrapper.removeAttribute("aria-hidden");
    } else {
      this.classList.remove("bits-box--expanded");
      this.contentWrapper.setAttribute("aria-hidden", "true");
    }
  }

  _refreshModuleVisibility() {
    const allVisible = this.currentTag === ALL_TAG;

    for (const bit of this.modules) {
      const visible = allVisible || bit.hasAttribute(`data-tag-${this.currentTag}`);

      if (visible) {
        bit.classList.remove("bits-content__module--hidden");
        bit.setAttribute("aria-hidden", "true");
      } else {
        bit.classList.add("bits-content__module--hidden");
        bit.removeAttribute("aria-hidden");
      }
    }
  }

  _refreshButtonStates() {
    for (let i = 0; i < this.tagButtons.length; i++) {
      if (this.currentTag === this.tagNames[i]) {
        this.tagButtons[i].classList.remove("button--secondary");
        this.tagButtons[i].classList.add("button--primary");
      } else {
        this.tagButtons[i].classList.remove("button--primary");
        this.tagButtons[i].classList.add("button--secondary");
      }
    }
  }

  _onHeaderClick(event) {
    this._setPersistentData(this.currentTag, !this.expanded);
  }

  _onFilterButtonClick(event) {
    this._setPersistentData(event.target.innerHTML, this.expanded);
  }
}

customElements.define('bart-bits-box', BartBitsBox);
